import React, { Fragment } from 'react';
import { Card, ListGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Cake, ClipboardClock, Send } from 'lucide-react';
import Loading from '../../components/loading';
import { useReminders } from '../hooks/useReminders';

export default function Reminders() {
  const { reminders, isLoading } = useReminders();

  function removeInvalidCharacteresToWhatsApp(patientPhoneNumber) {
    return patientPhoneNumber.replace(/[()\s-]/g, '');
  }

  const appointmentWhatsApp = (reminder) => {
    const phoneNumber = removeInvalidCharacteresToWhatsApp(reminder.patientPhoneNumber);
    const message = `Olá! Gostaríamos de confirmar a sua consulta. Por favor, responda "SIM" para confirmar.`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  const birthdayWhatsApp = (reminder) => {
    const phoneNumber = removeInvalidCharacteresToWhatsApp(reminder.patientPhoneNumber);
    const message = `Parabéns! Desejamos um dia especial, cheio de alegrias e muitos sorrisos saudáveis!`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <Card data-cy="reminders-card" className="rounded-4 shadow-lg border-0">
      <Card.Header className="border-0 py-3">
        <h5 className="mb-0 fw-bold text-muted">Lembretes</h5>
      </Card.Header>

      <Loading isToHidden={isLoading === false} />

      <div className="home-card-scroll">
        <ListGroup variant="flush">
          {reminders.map((reminder) => {
            const hasPhone = Boolean(reminder.patientPhoneNumber);

            const renderTooltip = (props) => (
              <Tooltip id={`tooltip-${reminder.id}`} {...props}>
                Paciente sem telefone cadastrado.
              </Tooltip>
            );

            return (
              <Fragment key={reminder.id}>
                <ListGroup.Item
                  data-cy="reminder-item"
                  className="d-flex flex-column flex-sm-row justify-content-sm-between align-items-start align-items-sm-center gap-2 py-3"
                >
                  <div className="d-flex align-items-center">
                    {reminder.type === 'Próximas Consultas' ? (
                      <ClipboardClock className="me-3 flex-shrink-0" size={20} />
                    ) : (
                      <Cake className="me-3 flex-shrink-0" size={20} />
                    )}
                    <div>
                      <p className="mb-1 text-body text-break">
                        <span data-cy="reminder-title" className="fw-bold">
                          {reminder.title}
                        </span>
                      </p>
                      <small data-cy="reminder-type" className="text-muted">
                        {reminder.type}
                      </small>
                    </div>
                  </div>

                  <div className="align-self-stretch align-self-sm-auto">
                    {reminder.type === 'Próximas Consultas' ? (
                      <OverlayTrigger placement="top" overlay={!hasPhone ? renderTooltip : <div />}>
                        <span className="d-inline-block">
                          <Button
                            data-cy="whatsapp-appointment-btn"
                            variant="outline-success"
                            size="sm"
                            onClick={() => appointmentWhatsApp(reminder)}
                            disabled={!hasPhone}
                            style={!hasPhone ? { pointerEvents: 'none' } : {}}
                          >
                            <Send size={16} className="me-2" />
                            Confirmar Consulta por WhatsApp
                          </Button>
                        </span>
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger placement="top" overlay={!hasPhone ? renderTooltip : <div />}>
                        <span className="d-inline-block">
                          <Button
                            data-cy="whatsapp-birthday-btn"
                            variant="outline-primary"
                            size="sm"
                            onClick={() => birthdayWhatsApp(reminder)}
                            disabled={!hasPhone}
                            style={!hasPhone ? { pointerEvents: 'none' } : {}}
                          >
                            <Send size={16} className="me-2" />
                            Enviar Felicitações por WhatsApp
                          </Button>
                        </span>
                      </OverlayTrigger>
                    )}
                  </div>
                </ListGroup.Item>
              </Fragment>
            );
          })}
        </ListGroup>
      </div>

      <Card.Body
        data-cy="reminders-empty"
        className="text-center py-5"
        hidden={reminders.length > 0}
      >
        <p className="text-muted mb-0">Nenhum lembrete para ser exibido no momento.</p>
      </Card.Body>
    </Card>
  );
}
